// Patient entity handler

import { IEntityHandler, MigrationOperation, MigrationResponse } from '../interfaces';
import { MigrationClient } from '../MigrationClient';
import { PatientTransformer } from '../transformers/PatientTransformer';

export class PatientHandler implements IEntityHandler {
  private migrationClient = MigrationClient.getInstance();
  private transformer = new PatientTransformer();

  async handleOperation(
    operation: MigrationOperation,
    amplifyData: Record<string, unknown>,
    amplifyResult?: Record<string, unknown>
  ): Promise<MigrationResponse> {
    console.log(`[PATIENT-HANDLER] ${operation} operation started`);
    
    // Extract the actual patient data from Amplify result or use input data
    const patientData = (amplifyResult as Record<string, Record<string, unknown>>)?.data?.createPatient || amplifyData;

    // Transform the data
    const transformedData = await this.transformer.transform(patientData as Record<string, unknown>);

    // Send to migration service
    return await this.migrationClient.invoke(operation, 'Patient', transformedData);
  }
} 